import TermsComponent from "../components/termscomponents/termscomponent"

const TermsPage = () => {

    return(
        <TermsComponent/>
    )
}

export default TermsPage